import API from '../../apis';
import { action, generateErrorAction } from '../actions';
import actionTypes from './actionTypes';

export const createGiftChairRequest = reqObject => {
  const request = () => {
    return dispatch => {
      dispatch(loading());
      return API.giftChair
        .createGiftChairRequest(reqObject)
        .then(res => dispatch(success(res)))
        .catch(err => {
          dispatch(
            generateErrorAction(err, {
              failure: actionTypes.CREATE_GIFT_CHAIRS_FAILED,
              reject: actionTypes.CREATE_GIFT_CHAIRS_REJECT,
            }),
          );
          throw err;
        });
    };
  };
  const loading = () => action(actionTypes.CREATE_GIFT_CHAIRS_LOADING);
  const success = res => action(actionTypes.CREATE_GIFT_CHAIRS_SUCCESS, res);

  return request();
};
